import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, ExternalLink, RefreshCw } from "lucide-react";
import { api, euro, data, dataOra, errMsg } from "@/lib/api";

export function Piano({ st }) {
  const [busy, setBusy] = useState(null);
  const paga = async (id) => {
    setBusy(id);
    try {
      const { data: d } = await api.post("/operatore/piano/checkout", { piano_id: id });
      window.location.href = d.url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(null);
    }
  };
  return (
    <div className="space-y-8">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {st.piani.map((p) => (
          <div key={p.id} className="card flex flex-col" data-testid={`piano-${p.id}`}>
            <p className="caption">{p.durata_mesi} mesi</p>
            <h3 className="font-display text-2xl mt-2">{p.nome}</h3>
            <p className="font-display text-4xl text-[#7E5BAF] mt-4">{euro(p.prezzo_cent)}</p>
            <button className="btn-primary mt-6" disabled={busy} onClick={() => paga(p.id)} data-testid={`piano-paga-${p.id}`}>
              <CreditCard size={16} />{busy === p.id ? "Reindirizzamento…" : ["attivo", "pagato_da_completare"].includes(st.operatore.stato) ? "Rinnova" : "Paga e attiva"}
            </button>
          </div>
        ))}
        {!st.piani.length && <p className="text-[#786E65]">Nessun piano disponibile al momento.</p>}
      </div>
      {st.operatore.stato === "attivo" && <p className="text-sm text-[#786E65]">Il rinnovo si somma alla scadenza attuale ({data(st.operatore.scadenza_spazio)}).</p>}
      <div className="card overflow-x-auto">
        <h3 className="font-display text-xl mb-3">Storico pagamenti spazio</h3>
        <table className="tbl" data-testid="pagamenti-table">
          <thead><tr><th>Data</th><th>Piano</th><th>Importo</th><th>Stato</th><th>Fattura</th></tr></thead>
          <tbody>
            {st.pagamenti.map((p) => (
              <tr key={p.id}><td>{dataOra(p.created_at)}</td><td>{p.piano_nome}</td><td>{euro(p.importo_cent)}</td>
                <td><span className={p.stato === "pagato" ? "badge-ok" : "badge-muted"}>{p.stato}</span></td>
                <td data-testid={`pagamento-fattura-${p.id}`}>{p.fattura ? `n. ${p.fattura.numero} · ${p.fattura.stato_sdi || (p.fattura.stato === "inviata" ? "inviata allo SDI" : "in emissione")}` : "—"}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function Incassi({ op, reload }) {
  const [busy, setBusy] = useState(false);
  const onboarding = async () => {
    setBusy(true);
    try {
      const { data: d } = await api.post("/operatore/connect/onboarding");
      window.location.href = d.url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  const aggiorna = async () => {
    const { data: d } = await api.post("/operatore/connect/aggiorna");
    toast(d.connect_pronto ? "Account incassi attivo" : "Onboarding non ancora completato");
    reload();
  };
  return (
    <div className="card max-w-2xl space-y-4" data-testid="incassi-panel">
      <h3 className="font-display text-2xl">Ricevi gli incassi con Stripe</h3>
      <p className="text-[#786E65] text-sm">Collega un account Stripe Express: il ricavato delle gift card viene accreditato direttamente a te, al netto dell'eventuale commissione della piattaforma ({op.commissione_pct}%).</p>
      <p data-testid="connect-stato">Stato: <span className={op.connect_pronto ? "badge-ok" : "badge-warn"}>{op.connect_pronto ? "Attivo" : op.stripe_account_id ? "Onboarding da completare" : "Non collegato"}</span></p>
      <div className="flex flex-wrap gap-3">
        <button className="btn-primary" disabled={busy} onClick={onboarding} data-testid="connect-onboarding-btn"><ExternalLink size={16} />{op.stripe_account_id ? "Continua onboarding" : "Collega Stripe"}</button>
        {op.stripe_account_id && <button className="btn-secondary" onClick={aggiorna} data-testid="connect-aggiorna-btn"><RefreshCw size={16} />Aggiorna stato</button>}
      </div>
    </div>
  );
}
